import { useLayoutEffect, useRef, useState } from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { getAddressSchema } from 'Modules/Requests/UpdatePersonalDetails/Schema';
import { useAppSelector } from './useAppSelector';
import { IUpdatePersonalDetails } from 'Interfaces/updatePersonalDetails';
import { ADDRESS_TYPES } from 'Enum';

export const useAddressForm = () => {
  const [isDirty, setIsDirty] = useState(false);
  const [isDifferentMailAddress, setIsDifferentMailAddress] = useState(false);
  const isReset = useRef<boolean>(false);

  const personalDetails = useAppSelector(
    ({ personalDetails: { personalDetails } }) => personalDetails
  );

  const getAddress = (type: number) =>
    personalDetails?.addresses?.filter(
      (address) => address.addressTypeId === type
    );

  const getInitialValues = () => {
    let initialValues: IUpdatePersonalDetails['addresses'] = [];
    const israeliAddress = getAddress(ADDRESS_TYPES.home);
    if (israeliAddress && israeliAddress.length > 0)
      initialValues.push({
        apartmentNum: israeliAddress[0].numApartment,
        city: israeliAddress[0].townId,
        houseNum: israeliAddress[0].numHouse,
        street: israeliAddress[0].street,
        zipCode: israeliAddress[0].zipCode,
        isAbroad: false,
        isMailBox: false,
      });
    else {
      const abroadAddress = getAddress(ADDRESS_TYPES.abroad);
      initialValues.push(
        abroadAddress && abroadAddress.length > 0
          ? {
              apartmentNum: abroadAddress[0].numApartment,
              abroadCity: abroadAddress[0].abroadTown,
              country: abroadAddress[0].countryId,
              houseNum: abroadAddress[0].numHouse,
              street: abroadAddress[0].street,
              zipCode: abroadAddress[0].zipCode,
              isAbroad: true,
              isMailBox: false,
            }
          : {
              apartmentNum: '',
              city: undefined,
              houseNum: '',
              street: '',
              zipCode: '',
              isAbroad: false,
              isMailBox: false,
            }
      );
    }

    const mailBoxAddress = getAddress(ADDRESS_TYPES.poBox);
    if (mailBoxAddress && mailBoxAddress.length > 0)
      initialValues.push(
        mailBoxAddress && mailBoxAddress.length > 0
          ? {
              city: mailBoxAddress[0].townId,
              mailBox: mailBoxAddress[0].postOffice,
              zipCode: mailBoxAddress[0].zipCode,
              isAbroad: false,
              isMailBox: true,
            }
          : {
              apartmentNum: '',
              city: undefined,
              houseNum: '',
              street: '',
              zipCode: '',
              isAbroad: false,
              isMailBox: false,
            }
      );

    return initialValues;
  };

  const addressForm = useForm<{
    addresses: IUpdatePersonalDetails['addresses'];
  }>({
    mode: 'onBlur',
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    resolver: yupResolver(
      getAddressSchema(isDirty, isDifferentMailAddress) as any
    ),
    defaultValues: { addresses: getInitialValues() },
  });

  useLayoutEffect(() => {
    setIsDirty(addressForm.formState.isDirty);
  }, [addressForm.formState.isDirty]);

  return {
    addressForm,
    isDifferentMailAddress,
    setIsDifferentMailAddress,
    isReset,
  };
};
